import { observer } from 'mobx-react';
import React, { useCallback, useEffect } from 'react';
import MicIcon from '@material-ui/icons/Mic';
import MicOffIcon from '@material-ui/icons/MicOff';
import VideocamIcon from '@material-ui/icons/Videocam';
import VideocamOffIcon from '@material-ui/icons/VideocamOff';
import { IconButton } from '@material-ui/core';
import classNames from 'classnames';
import { isMobile } from 'react-device-detect';

import ProfileStore from 'stores/ProfileStore';
import UserStore from 'stores/UserStore';
import { setPrivateShowAction } from 'webchat/webchatCalls';

import styles from './index.css';


const Cam2CamControls = () => {
  const {
    c2cAudioMuted,
    c2cVideoMuted,
    c2cViewerStreamStarted,
    setC2CAudioMuted,
    setC2CVideoMuted,
    user,
  } = UserStore;

  const { username, accessHash } = user;
  const { profileName: roomname } = ProfileStore;

  const updateC2CSettingsInFirebase = useCallback(async(c2cViewerAudioMuted, c2cViewerVideoMuted) => {
    if (!(username && accessHash && roomname && c2cViewerStreamStarted)) {
      return;
    }

    await setPrivateShowAction({
      action: 'updatePSViewerSettings',
      username: username.toLowerCase(),
      accessHash,
      roomname,
      c2cViewerAudioMuted,
      c2cViewerVideoMuted,
    });
  }, [username, accessHash, roomname, c2cViewerStreamStarted]);

  const onToggleAudioMuted = useCallback(() => {
    setC2CAudioMuted(!c2cAudioMuted);
    updateC2CSettingsInFirebase(!c2cAudioMuted, c2cVideoMuted);
  }, [c2cAudioMuted, c2cVideoMuted, setC2CAudioMuted, updateC2CSettingsInFirebase]);

  const onToggleVideoMuted = useCallback(() => {
    setC2CVideoMuted(!c2cVideoMuted);
    updateC2CSettingsInFirebase(c2cAudioMuted, !c2cVideoMuted);
  }, [c2cVideoMuted, c2cAudioMuted, setC2CVideoMuted, updateC2CSettingsInFirebase]);

  useEffect(() => () => {
    setC2CAudioMuted(false);
    setC2CVideoMuted(false);
  }, [setC2CAudioMuted, setC2CVideoMuted]);

  const MicComponent = c2cAudioMuted ? MicOffIcon : MicIcon;
  const VideoComponent = c2cVideoMuted ? VideocamOffIcon : VideocamIcon;

  const audioButtonClassnames = [
    styles.button, {
      [styles.muted]: c2cAudioMuted,
      [styles.mobileButton]: isMobile,
    },
  ];
  const videoButtonClassnames = [
    styles.button, {
      [styles.muted]: c2cVideoMuted,
      [styles.mobileButton]: isMobile,
    },
  ];

  const containerClassses = classNames({
    [styles.container]: !isMobile,
    [styles.mobileContainer]: isMobile,
  });

  return (
    <div className={containerClassses}>
      {!isMobile && (
        <span className={styles.title}>Cam2Cam</span>
      )}

      <IconButton
        aria-label="mute audio"
        className={classNames(audioButtonClassnames)}
        size="small"
        onClick={onToggleAudioMuted}
      >
        <MicComponent fontSize="small" />
      </IconButton>

      <IconButton
        aria-label="disable video"
        className={classNames(videoButtonClassnames)}
        size="small"
        onClick={onToggleVideoMuted}
      >
        <VideoComponent fontSize="small" />
      </IconButton>
    </div>
  );
};

export default observer(Cam2CamControls);
